import { Directive, ElementRef, Renderer2, afterNextRender, inject } from '@angular/core';

/**
 * Reports when a panel sized to its rows still truncates one of them.
 *
 * A row wider than the panel's own ceiling adds `is-clipped` to the host, which
 * is the signal styles need to offer horizontal resizing only where it would
 * reveal something. The check runs on the rendered elements because the row
 * markup comes from a template shared with a table cell, which view
 * encapsulation puts out of reach of the panel's stylesheet.
 */
@Directive({
  selector: '[appContentSizedPanel]',
  standalone: true
})
export class ContentSizedPanelDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);

  constructor() {
    afterNextRender(() => this.fitToRows());
  }

  private fitToRows(): void {
    const panel = this.host.nativeElement;
    const isClipped = Array.from(panel.querySelectorAll<HTMLElement>('*')).some(
      (element) => element.scrollWidth > element.clientWidth
    );

    if (isClipped) {
      this.renderer.addClass(panel, 'is-clipped');
    }
  }
}
